<script setup lang="ts">
import { useStation } from "@/api/station-query";
import Frame from "@/components/common/Frame.vue";
import SettingsHeader from "@/components/common/SettingsHeader.vue";
import { icRemoteOutline } from "@/components/icons";
import StationSelection from "@/components/map/object-selection/StationSelection.vue";
import CustomRouterView from "@/layouts/content/CustomRouterView.vue";
import Drawer from "@/layouts/drawer/Drawer.vue";
import DrawerLayout from "@/layouts/drawer/DrawerLayout.vue";
import { DrawerSelection } from "@/layouts/drawer/use-drawer-data";

const route = useRoute();
const id = computed(() => route.params.id as string);
const { data: station } = useStation(id);

const router = useRouter();
function changePage(selection: DrawerSelection) {
	router.push({
		name: "stations-id-index",
		params: { id: selection.id },
		query: { ...route.query },
	});
}
</script>

<template>
	<DrawerLayout>
		<template #drawer>
			<Drawer :objects="['station']" @click="changePage" />
		</template>
		<div class="h-full overflow-auto">
			<SettingsHeader
				:icon="icRemoteOutline"
				:name="station?.name"
				sourceType="station"
				:sourceId="id"
			>
				<StationSelection v-if="station" :station="station" />
			</SettingsHeader>
			<Frame>
				<CustomRouterView />
			</Frame>
		</div>
	</DrawerLayout>
</template>
